'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

import Icon from '@/components/ui/icon'
import { useConfigContext } from '@/context/ConfigProvider'
import { eGeneralInfo } from '@/types/enum'

export default function Social() {
  const { getBasic } = useConfigContext()
  const t = useTranslations('footer')

  const socials = [
    { icon: 'tgic icon-youtube-square', href: `${getBasic(eGeneralInfo.youtube_page) || '/'}` },
    { icon: 'tgic icon-facebook-square', href: `${getBasic(eGeneralInfo.facebook_page) || '/'}` },
    { icon: 'tgic icon-twitter-x-square', href: `${getBasic(eGeneralInfo.twitter_page) || '/'}` },
    { icon: 'tgic icon-linkedin-square', href: `${getBasic(eGeneralInfo.linkedin_page) || '/'}` },
    { icon: 'tgic icon-instagram-square', href: `${getBasic(eGeneralInfo.instagram_page) || '/'}` },
    { icon: 'tgic icon-tiktok-square', href: `${getBasic(eGeneralInfo.tiktok_page) || '/'}` },
  ]

  return (
    <div className="text-sm space-y-3">
      <p className="uppercase font-bold">{t('connect_us')}</p>
      <div className="flex gap-4">
        {socials?.slice(0, 3).map((route) => (
          <div key={route.icon} className="text-lg">
            <Link
              prefetch={false}
              href={route.href}
              target="_blank"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border hover:text-primary duration-100"
            >
              <Icon icon={route.icon} />
            </Link>
          </div>
        ))}
      </div>
      <div className="flex gap-4">
        {socials?.slice(3, 6).map((route) => (
          <div key={route.icon} className="text-lg">
            <Link
              prefetch={false}
              href={route.href}
              target="_blank"
              className="inline-flex items-center justify-center w-10 h-10 rounded-full border hover:text-primary hover:border-primary duration-100"
            >
              <Icon icon={route.icon} />
            </Link>
          </div>
        ))}
      </div>
      <Link prefetch={false} href={`${getBasic(eGeneralInfo.online_gov_register) || '/'}`} target="_blank" className="inline-block hover:opacity-80">
        <Image src="/assets/images/footer/tbao.webp" alt="Thông báo bộ công thương" width={110} height={40} draggable={false} unoptimized priority className="w-[110px] h-[40px]" />
      </Link>
    </div>
  )
}
